/**
 * WorkspaceShell — the app shell, 30+ surfaces live inside.
 * Layout: top nav (workspace tabs) + main view + peek panel.
 * Per app-codex.surfaces: this composes 9 surfaces.
 */
import { useApp } from '../store'
import { TopNav } from './TopNav'
import { PeekPanel } from './PeekPanel'
import { TodayView } from './TodayView'
import { CalendarView } from './CalendarView'
import { ChatView } from './ChatView'
import { ResourcesView } from './ResourcesView'
import { HistoryView } from './HistoryView'
import { AchievementsView } from './AchievementsView'

export function WorkspaceShell() {
  const { activeWorkspace } = useApp()

  return (
    <div className="min-h-screen bg-skin-bg text-skin-text">
      <TopNav />
      <main className="max-w-7xl mx-auto px-4 py-6 pb-24 md:pb-6">
        {activeWorkspace === 'tasks' && <TodayView />}
        {activeWorkspace === 'calendar' && <CalendarView />}
        {activeWorkspace === 'chat' && <ChatView />}
        {activeWorkspace === 'resources' && <ResourcesView />}
        {activeWorkspace === 'history' && <HistoryView />}
        {activeWorkspace === 'achievements' && <AchievementsView />}
      </main>
      <PeekPanel />
    </div>
  )
}
